var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocationIconSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.822 2C6.717 2 4.2 4.5 4.2 7.604 4.2 11.8 9.822 18 9.822 18s5.621-6.201 5.621-10.396C15.443 4.5 12.927 2 9.822 2z",
    stroke: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.821 9.438a1.99 1.99 0 100-3.979 1.99 1.99 0 000 3.979z",
    stroke: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuODIxODIgMkM2LjcxNjk1IDIgNC4yMDAyIDQuNDk5NDYgNC4yMDAyIDcuNjA0MzJDNC4yMDAyIDExLjc5ODkgOS44MjE4MiAxOCA5LjgyMTgyIDE4QzkuODIxODIgMTggMTUuNDQzNCAxMS43OTg5IDE1LjQ0MzQgNy42MDQzMkMxNS40NDM0IDQuNDk5NDYgMTIuOTI2NyAyIDkuODIxODIgMloiIHN0cm9rZT0id2hpdGUiLz4KPHBhdGggZD0iTTkuODIxMjIgOS40Mzc4NUMxMC45MTk4IDkuNDM3ODUgMTEuODEwNCA4LjU0NzI2IDExLjgxMDQgNy40NDg2NkMxMS44MTA0IDYuMzUwMDYgMTAuOTE5OCA1LjQ1OTQ3IDkuODIxMjIgNS40NTk0N0M4LjcyMjYyIDUuNDU5NDcgNy44MzIwMyA2LjM1MDA2IDcuODMyMDMgNy40NDg2NkM3LjgzMjAzIDguNTQ3MjYgOC43MjI2MiA5LjQzNzg1IDkuODIxMjIgOS40Mzc4NVoiIHN0cm9rZT0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgLocationIconSvg as ReactComponent };